// 사용자 쿠폰 API 래퍼.

import type { CouponDto } from "@oo/shared";
import { api } from "@/api/client.ts";

// 내 쿠폰함 조회.
export async function getCoupons(): Promise<CouponDto[]> {
  const data = await api.get<{ coupons: CouponDto[] }>("/me/coupons");
  return data.coupons;
}
